import Swiper from 'swiper'
import { Autoplay } from 'swiper/modules'

export default function initializeSwiper() {
  const swiper = new Swiper('.en-lower__swiper-container', {
    // configure Swiper to use modules
    modules: [Autoplay],

    centeredSlides: true,
    slidesPerView: 'auto',
    allowTouchMove: false,
    loop: true,
    speed: 3000,

    autoplay: {
      delay: 0
    },
  })
}
